<template lang="pug">
  <div class="page-level">
    <form name="contact" netlify>
      <p>
        <label>Your Name: <input type="text" name="name"></label>
      </p>
      <p>
        <label>Your Email: <input type="email" name="email"></label>
      </p>
      <p>
        <label>Message: <textarea name="message"></textarea></label>
      </p>
      <p>
        <button type="submit">Send</button>
      </p>
  </form>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// Submission.vue?d8c841ea